/**
 * Invoicing domain service — facade over AdminService for invoicing operations.
 *
 * Methods: invoice config, batches, billing config, usage billing.
 */
import { adminService } from '../auth';

export const invoicingService = {
  // Invoice config
  getInvoiceConfig: adminService.getInvoiceConfig.bind(adminService),
  updateInvoiceConfig: adminService.updateInvoiceConfig.bind(adminService),

  // Invoice batches
  listInvoiceBatches: adminService.listInvoiceBatches.bind(adminService),
  searchInvoiceBatches: adminService.searchInvoiceBatches.bind(adminService),
  getInvoiceBatch: adminService.getInvoiceBatch.bind(adminService),
  resendInvoiceBatch: adminService.resendInvoiceBatch.bind(adminService),
  resendDelivery: adminService.resendDelivery.bind(adminService),
  listActivitiesByBatch: adminService.listActivitiesByBatch.bind(adminService),
  createManualBatch: adminService.createManualBatch.bind(adminService),

  // Billing config & reports
  getBillingConfig: adminService.getBillingConfig.bind(adminService),
  updateBillingConfig: adminService.updateBillingConfig.bind(adminService),
  getBillingReportData: adminService.getBillingReportData.bind(adminService),
  downloadBillingInvoicePdf: adminService.downloadBillingInvoicePdf.bind(adminService),
  emailBillingInvoice: adminService.emailBillingInvoice.bind(adminService),

  // Usage billing
  listUsageBillingInvoices: adminService.listUsageBillingInvoices.bind(adminService),
  getUsageBillingInvoice: adminService.getUsageBillingInvoice.bind(adminService),
  generateUsageBillingInvoice: adminService.generateUsageBillingInvoice.bind(adminService),
  resendUsageBillingInvoice: adminService.resendUsageBillingInvoice.bind(adminService),
  listAllUsageBillingInvoices: adminService.listAllUsageBillingInvoices.bind(adminService),
  markUsageBillingInvoiceUnpaid: adminService.markUsageBillingInvoiceUnpaid.bind(adminService),
  viewUsageBillingPDF: adminService.viewUsageBillingPDF.bind(adminService),
} as const;
